import moment from "moment";

const Constants = {
  base_url: process.env.BASE_URL,
  api_url: process.env.VUE_APP_API_URL,
  api_base_url: process.env.VUE_APP_API_BASE_URL,
  menuItems: [
    { name: 'Masters', to: '/masters', icon: 'mdi-table-settings' },
    { name: 'Trips', to: '/trips', icon: 'mdi-led-strip-variant' },
   /* { name: 'Trips Dashboard', to: '/trips-dashboard', icon: 'mdi-led-strip-variant' }, */
    { name: 'Customers', to: '/customers', icon: 'mdi-office-building' },
    { name: 'Products', to: '/products', icon: 'mdi-gift-outline' },
    { name: 'Purchase', to: '/purchaseOrder', icon: 'mdi-cart-arrow-down' },
    { name: 'Sales Orders', to: '/salesOrder', icon: 'mdi-cart-arrow-up' },
  ],
  successToast: {
    theme: 'primary', position: 'top-right',
    duration: 3000, className: 'success-toast',
  },
  errorToast: {
    theme: 'primary', position: 'top-right',
    duration: 3000, className: 'error-toast',
  },
}
export default Constants
export const dateOptions = {
  'Today': [moment().toDate(), moment().toDate()],
  'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
  'Last Week': [moment().subtract(7, 'days').toDate(), moment().toDate()],
  'This Week': [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
  'Last Month': [
    moment().subtract(1, 'month').startOf('month').toDate(),
    moment().subtract(1, 'month').endOf('month').toDate()],
  'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
}

export function generateUUID (){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}